import { JobCornSchema } from '@eigtech/restoration-types';
import { CurrentClaimCornSchema } from '@eigtech/shared-corn-helper';
import { z } from 'zod';
import { PhotoReportRecordSchema } from '../base/photoReport.js';
export const GeneratePhotoReportPathSchema = z.object({
    entityId: z.union([CurrentClaimCornSchema, JobCornSchema]),
});
export const GeneratePhotoReportBodySchema = z.object({
    documentIds: z.string().array(),
});
export const GeneratePhotoReportHeadersSchema = z.object({
    requestActor: z.string(),
});
export const GeneratePhotoReportResponseSchema = PhotoReportRecordSchema;
export const GeneratePhotoReportRequestSchema = GeneratePhotoReportPathSchema.merge(GeneratePhotoReportBodySchema).merge(GeneratePhotoReportHeadersSchema);
export const GeneratePhotoReportApiSchema = {
    params: GeneratePhotoReportPathSchema,
    body: GeneratePhotoReportBodySchema,
    headers: GeneratePhotoReportHeadersSchema,
    response: GeneratePhotoReportResponseSchema,
};
